export default "__VITE_ASSET__28413ff0__"